import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from "react-toastify";


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    
    <UserProvider>
      <App />
       <ToastContainer />
    </UserProvider>
  </React.StrictMode>
);